import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  justify-content: space-between;
`;

export const Header = styled.div`
  font-family: 'Roboto';
  font-style: normal;
`;

export const HeaderUp = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 16px;
  align-items: center;
`;

export const Title = styled.h2`
  font-weight: 400;
  font-size: 18px;
  color: rgba(0, 0, 0, 0.65);

  .protocol {
    font-weight: 600;
    font-size: 24px;

    margin-right: 10px;
  }
`;
